import { initializeTokapiAxiosInstance } from '@workspace/frontend-kit'
import { setTokapiAxiosInstance } from '@toktokdoctech/tokapi-client'
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import { ApolloProvider } from '@apollo/client'
import { Integrations } from '@sentry/tracing'
import * as Sentry from '@sentry/react'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
// import FlagProvider, { UnleashClient } from '@unleash/proxy-client-react'
import moment from 'moment-timezone'
import 'moment/locale/fr'
import packageJson from '../package.json'

import './assets/css/styles.css'
// import unleashConfig from './app/config/flagProvider'
import apolloClient from './app/config/apolloClient'
import { store } from './app/store'
import AppEntry from './app/AppEntry'
import { SessionContext } from './app/context/SessionContext'
import { tracker } from './tracking'

tracker.init()

moment.locale('fr')
moment.localeData('fr')
moment.tz.setDefault('Europe/Paris')

/* SETUP SENTRY ON STG AND PROD */
if (!window.location.host.includes('localhost')) {
    Sentry.init({
        dsn: 'https://6b53cae966674a5a9d5045ea43bd3f8b@sentry.io/1222287',
        integrations: [new Integrations.BrowserTracing()],
        environment: window._env_.REACT_APP_TTD_ENV,
        release: `doctor_${packageJson.version}`,
        tracesSampleRate: 1.0,
    })
} else {
    console.log('[APP] Sentry disabled reason: loval env')
}

// const unleashClient = new UnleashClient(unleashConfig)
// let startUnleashClient = false
// if (window._env_.REACT_APP_TTD_ENV === 'production') startUnleashClient = true

const queryClient = new QueryClient()

const tokapiUrl = window._env_.REACT_APP_TOKAPI_DOCTOR || ''
const authRedirectUrl = `${window._env_.REACT_APP_HDS_HOST}/login?redirect=${window._env_.REACT_APP_CUR_AUTH_CLBC}`
const tokapiAxiosInstance = initializeTokapiAxiosInstance(tokapiUrl, authRedirectUrl)
setTokapiAxiosInstance(tokapiAxiosInstance)

// new way to create app since react v18
const container = document.getElementById('app')
// @ts-expect-error TS(2345) FIXME: Argument of type 'HTMLElement | null' is not assig... Remove this comment to see the full error message
const root = createRoot(container) // createRoot(container!) if you use TypeScript

root.render(
    <Provider store={store}>
        {/* <FlagProvider unleashClient={unleashClient} startClient={startUnleashClient}> */}
        <SessionContext>
            <QueryClientProvider client={queryClient}>
                <ApolloProvider client={apolloClient}>
                    <AppEntry />
                </ApolloProvider>
            </QueryClientProvider>
        </SessionContext>
        {/* </FlagProvider> */}
    </Provider>
)
